<template>
  <div class="attr-text">
    <h4 class="c-ellipsis">文本操作设置</h4>
    <section>
      <ul>
        <template v-if="!tplData.free">
          <li>
            <el-checkbox v-model="value.disabled">禁止操作</el-checkbox>
          </li>
          <li>
            <el-checkbox v-model="value.fixed" key="2">禁止联动</el-checkbox>
          </li>
          <li v-if="!isSingleTemplate">
            <el-checkbox v-model="value.allowHide" key="3"
              >支持隐藏</el-checkbox
            >
          </li>
          <li>
            <el-checkbox v-model="value.isMoreRow" key="4"
              >多行文本</el-checkbox
            >
          </li>
          <li v-if="isSingleTemplate">
            <el-checkbox v-model="value.isActionText" key="5"
              >行动点文案</el-checkbox
            >
          </li>
          <li v-if="isSingleTemplate">
            <el-checkbox
              v-model="value.fixedColor"
              key="6"
              title="更换主题色时不做替换"
              >固定颜色</el-checkbox
            >
          </li>
        </template>
        <li class="m-top flex-start" v-if="!tplData.free">
          <label style="margin-top: 7px">字数</label>
          <el-input-number
            :min="0"
            placeholder="文本长度限制"
            style="width: 215px"
            v-model="value.maxLength"
            controls-position="right"
          ></el-input-number>
        </li>
        <li class="text-space m-top flex-start">
          <label style="margin-top: 7px">字体</label>
          <div>
            <el-select
              v-if="fontList.length > 0"
              v-model="value.fontFamily"
              filterable
              class="font-family"
              popper-class="font-family-options-wrap mf-dialog"
              @change="onFontChange"
              style="width: 215px"
            >
              <el-option
                v-for="font in fontList"
                :key="font.id"
                :label="font.fontFamily"
                :value="font.psName"
              >
                <img :src="font.preview" height="18"/>
              </el-option>
              <div slot="empty"></div>
              <div class="mf-link-wrap">
                <a href="/#/admin/projFont" target="_blank">去上传字体 &rarr;</a>
              </div>
            </el-select>
            <!-- <el-select
              v-model="value.fontFamily"
              filterable
              class="font-family"
              popper-class="font-family-options-wrap"
              @change="onFontChange"
            >
              <el-option-group  v-if="value.missingFont"
                  key="-1"
                  label="缺失字体">
                <el-option :value="value.fontFamily"  :label="value.fontFamily"></el-option>
              </el-option-group>
              <el-option-group
                  v-for="group in fontList"
                  :key="group.label"
                  :label="group.label">
                <el-option v-for="(item, index) in group.options" :value="item.name" :label="item.alias" :key="index">
                  <div class="c-font-option" :title="item.alias">
                    <span class="cfo-label">{{ item.alias }}</span>
                    <a class="cfo-upload" v-if="group.label === group_pro_label" @click.stop="onClickUpload(item)">
                      <font-uploader btnType="text" btnName="重新上传" :autoSave="false" :projectId="tplData.projectId" @onAdd="onSuccess"></font-uploader>
                    </a>
                  </div>
                </el-option>
              </el-option-group>
            </el-select> -->
            <!-- <p v-if="value.missingFont"><i class="el-icon-warning font-warn"></i>当前模板字体缺失 请<a
                @click="onOpenMissingFont">立即上传</a></p> -->
          </div>
        </li>
        <!-- <div><el-input-number></el-input-number></div> -->
        <li
          class="text-space m-top flex-start"
          v-if="$store.getters['app/isAdmin']"
        >
          <label style="margin-top: 7px">字号</label>
          <el-input-number
            v-model="value.fontSize"
            style="width: 215px"
            class="font-size"
            :min="1"
            controls-position="right"
            @change="onTextPositionChange"
          ></el-input-number>
        </li>
        <li
          class="text-space m-top flex-start"
          v-if="$store.getters['app/isAdmin']"
        >
          <label style="margin-top: 7px">颜色</label>
          <color-input v-model="value.color" style="width: 215px"></color-input>
        </li>
        <li
          class="text-space m-top flex-start"
          v-if="$store.getters['app/isAdmin']"
        >
          <label>透明</label>
          <opacity v-model="value.opacity"></opacity>
        </li>
        <li class="text-space m-top">
          <label>行间距</label>
          <el-input-number
            controls-position="right"
            class="ts-input"
            type="text"
            v-model="value.lineHeight"
            @change="onTextPositionChange"
          ></el-input-number>
          <label style="margin-left: 5px">字间距</label>
          <el-input-number
            controls-position="right"
            class="ts-input"
            type="text"
            v-model="value.letterSpacing"
          ></el-input-number>
        </li>
        <li class="m-top">
          <label>对齐</label>
          <span class="align-box">
            <el-tooltip effect="dark" content="左对齐" placement="top">
              <i
                class="myico-align-left"
                :class="{ active: value.textAlign === 'left' }"
                @click="onClickTextAlign('left')"
              ></i>
            </el-tooltip>
            <el-tooltip effect="dark" content="居中对齐" placement="top">
              <i
                class="myico-align-center"
                :class="{ active: value.textAlign === 'center' }"
                @click="onClickTextAlign('center')"
              ></i>
            </el-tooltip>
            <el-tooltip effect="dark" content="右对齐" placement="top">
              <i
                class="myico-align-right"
                :class="{ active: value.textAlign === 'right' }"
                @click="onClickTextAlign('right')"
              ></i>
            </el-tooltip>
            <el-tooltip effect="dark" content="两端对齐" placement="top">
              <i
                class="myico-align-justify"
                :class="{ active: value.textAlign === 'justify' }"
                @click="onClickTextAlign('justify')"
              ></i>
            </el-tooltip>
            <el-tooltip effect="dark" content="斜体" placement="top">
              <i
                class="myico-font-style"
                :class="{ active: value.fontStyle === 'italic' }"
                @click="onClickFontStyle"
              ></i>
            </el-tooltip>
          </span>
        </li>
        <li class="m-top">
          <label>排版</label>
          <span class="align-box">
            <el-tooltip effect="dark" content="横排文本" placement="top">
              <i
                class="myico-text-horizontal"
                :class="{ active: value.writingMode === 'initial' }"
                @click="onClickWritingMode('initial')"
              ></i>
            </el-tooltip>
            <el-tooltip effect="dark" content="竖排向左" placement="top">
              <i
                class="myico-text-vertical-l"
                :class="{ active: value.writingMode === 'vertical-rl' }"
                @click="onClickWritingMode('vertical-rl')"
              ></i>
            </el-tooltip>
            <el-tooltip effect="dark" content="竖排向右" placement="top">
              <i
                class="myico-text-vertical-r"
                :class="{ active: value.writingMode === 'vertical-lr' }"
                @click="onClickWritingMode('vertical-lr')"
              ></i>
            </el-tooltip>
          </span>
        </li>
      </ul>
    </section>
    <section>
      <h4>
        <el-checkbox v-model="textShadow" key="3" @change="onTextShadowCheck"
          >阴影</el-checkbox
        >
      </h4>
      <text-shadow
        v-model="value.textShadow"
        @change="onTextShadowChange"
      ></text-shadow>
    </section>
    <section>
      <h4 class="c-ellipsis">文字微调</h4>
      <div class="layer-position">
        <div class="c-flex lp-item">
          <span>下移</span>
          <el-input-number
            type="number"
            controls-position="right"
            size="small"
            placeholder="下移"
            @keydown.native.stop
            @change="onPositionChange"
            v-model="value.top"
          >
            <i
              class="el-input__icon self-icon el-icon-bottom"
              slot="suffix"
            ></i>
          </el-input-number>
        </div>
        <div class="c-flex lp-item">
          <span>右移</span>
          <el-input-number
            type="number"
            controls-position="right"
            size="small"
            placeholder="右移"
            @keydown.native.stop
            @change="onPositionChange"
            v-model="value.left"
          >
            <i class="el-input__icon self-icon el-icon-right" slot="suffix"></i>
          </el-input-number>
        </div>
      </div>
      <div class="layer-position">
        <div class="c-flex lp-item">
          <span>宽度</span>
          <el-input-number
            type="number"
            controls-position="right"
            size="small"
            placeholder="宽度"
            @keydown.native.stop
            @change="onPositionChange"
            v-model="value.width"
          >
            <i class="el-input__icon self-icon" slot="suffix">w</i>
          </el-input-number>
        </div>
        <div class="c-flex lp-item">
          <span>高度</span>
          <el-input-number
            type="number"
            controls-position="right"
            size="small"
            placeholder="高度"
            @keydown.native.stop
            @change="onPositionChange"
            v-model="value.height"
          >
            <i class="el-input__icon self-icon" slot="suffix">h</i>
          </el-input-number>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { group_type_pt, template_type_single } from '@/const.js'
import textShadow from '../../components/text-shadow/index'
import colorInput from '../../components/color-input'
import opacity from '../../components/opacity/opacity-index'
import util from '@/util'
// import fontUploader from '../../template/font/font-uploader';
import fontService from '../../../request/service/font-service'
const group_pro_label = '上传字体'
export default {
  components: {
    textShadow,
    colorInput,
    opacity
    // fontUploader
  },
  props: {
    value: Object,
    tplData: Object
  },
  data () {
    return {
      textShadow,
      group_pro_label
    }
  },
  computed: {
    fontList () {
      let { sysFont, projFont, unSetSysFont } = this.$store.state.app.allFontObj
      // let dataList = []
      // if (unSetSysFont) {
      //   dataList.push({ label: '默认字体', options: unSetSysFont })
      // }
      // if (projFont) {
      //   dataList.push({ label: group_pro_label, options: projFont })
      // }
      // if (sysFont) {
      //   dataList.push({ label: '公共字体', options: sysFont })
      // }
      // console.log(111, dataList)
      return projFont
    },
    isSingleTemplate () {
      return this.tplData.type === template_type_single
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.textShadow = this.value.textShadow ? true : false
      this.fontList.forEach(item => {
        if (this.value.fontFamily === item.name) {
          this.value.missingFont = false
        }
      })
    },
    onClickTextAlign (value) {
      this.value.textAlign = value
    },
    swopWithAndHeight (item, currentVal) {
      let oldVal = item.writingMode || 'initial'
      if (oldVal === 'initial' || currentVal === 'initial') {
        let { width, height } = item
        item.height = width
        item.width = height
        item.bottom = +item.height + +item.top
        item.right = +item.width + +item.left
      }
    },
    onClickWritingMode (value) {
      let item = this.value
      if (item.writingMode === value) {
        return
      }
      let notSwop1 = item.writingMode === undefined && value === 'initial' // 首次选择横排
      if (notSwop1) {
        return
      }
      this.swopWithAndHeight(item, value)
      if (item.writingMode === undefined) {
        this.$set(item, 'writingMode', value)
      } else {
        item.writingMode = value
      }
      if (['vertical-lr', 'vertical-rl'].indexOf(value) > -1) {
        item.isMoreRow = true
      }
    },
    onTextShadowCheck (v) {
      if (!v) {
        this.value.textShadow = ''
      }
    },
    onTextShadowChange (v) {
      this.textShadow = v ? true : false
    },
    onFontChange (v) {
      this.value.missingFont = false
      this.value.beforeFontFamily = null
      let idx = this.fontList.findIndex(item => {
        return item.psName === v
      })
      if (idx > -1) {
        let item = this.fontList[idx]
        util.downloadFont(item.psName, item.url)
      }
    },
    onClickFontStyle () {
      let fontStyle = this.value.fontStyle
      let newVal = fontStyle === 'italic' ? '' : 'italic'
      if (fontStyle === undefined) {
        this.$set(this.value, 'fontStyle', newVal)
      } else {
        this.value.fontStyle = newVal
      }
    },
    onOpenMissingFont () {
      this.eventBus.$emit('onOpenMissingFont')
    },
    onPositionChange () {
      let item = this.value
      item.right = +item.left + +item.width
      item.bottom = +item.top + +item.height
    },
    onTextPositionChange () {
      let item = this.value
      if (!item.lineHeightScale && item.fontSize && item.lineHeight) {
        item.lineHeightScale = parseFloat(
          (item.lineHeight / item.fontSize).toFixed(2)
        )
      }
    },
    onClickUpload (fontItem) {
      this.currentFont = fontItem
    },
    onSuccess ({ url, cover, mainNameOnFile }) {
      this.currentFont.mainNameOnFile = mainNameOnFile
      this.currentFont.url = url
      this.currentFont.cover = cover
      fontService
        .updateFontUrl(this.currentFont, this.tplData.projectId)
        .then(() => {
          this.$alert('字体已上传，5分钟后生效，支持导出')
        })
    }
  }
}
</script>
